import { render, staticRenderFns } from "./DeliveryStatisticsModule.vue?vue&type=template&id=58ec58b9"
import script from "./DeliveryStatisticsModule.vue?vue&type=script&lang=js"
export * from "./DeliveryStatisticsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports